import React from 'react';

/**
 * BlockErrorBoundary — isolates a single Puck block. If one block throws
 * while rendering, we show a subtle placeholder instead of crashing the
 * whole page. One bad block never takes down the page.
 */
export default class BlockErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    // eslint-disable-next-line no-console
    console.warn(`[PuckPage] block "${this.props.type}" failed to render:`, error);
  }

  render() {
    if (this.state.failed) {
      return (
        <div className="px-4 py-3">
          <div className="rounded-xl border border-dashed border-gray-200 bg-gray-50 px-4 py-3 text-center text-xs text-gray-400">
            Contenu non disponible
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
